import React, { useState, useEffect } from 'react';
import { createDoses, getDosesList } from '../../../services/Doses.service';
import DatePicker from '../../DatePicker/DatePicker.component';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import { Button, makeStyles, TextField, Typography, Grid, Select, MenuItem, InputLabel } from '@material-ui/core';
import Dialog from '../../ui/Dialog';
import moment from 'moment';


const AddDoses = ({ data }) => {
    const currentDate = new Date();
    const [openModal, setOpenModal] = useState(false);
    const [openConfirmation, setConfirmation] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [errorInputMessage, setErrorInputMessage] = useState(null);
    const [doseDetails, setDoseDetails] = useState({
        dose_date: currentDate.toDateString(),
        dose_number: '',
        brand_id: 'nucala',

    });
    const [touchedFields, setTouchedFields] = useState({
        dose_number: false,
        brand_id: false,
    });
    const [dosesList, setDosesList] = useState([]);

    const { match } = data;
    const programId = match.params.connect_program_id;
    const queryString = window.location.search;
    const searchParams = new URLSearchParams(queryString);
    const patient_id = searchParams.get('patient_id');

    const useStyles = makeStyles(() => ({
        field: {
            marginBottom: 10,
            width: '100%',
            minWidth: '500px'
        },
        select: {
            width: '100%'
        },
        formControl: {
            width: '100%'
        },
        customWidth: {
            '& .MuiDialog-paper': {
                width: '800px',
                maxWidth: '800px',
            }
        },
        errorText: {
            color: 'red',
            fontSize: '0.75rem',
            marginTop: 3,
        }
    }));

    const classes = useStyles();


    useEffect(() => {
        const fetchDosesList = async () => {
            try {
                const { result } = await getDosesList({
                    program_id: programId,
                    patient_id: patient_id
                });

                let dosesList = [];

                if (result) {
                    dosesList = result;
                }

                dosesList.unshift({ label: 'Select Dose', value: '' });
                setDosesList(dosesList);
            } catch (error) {
                console.error('Error fetching Doses list:', error);
            }
        };

        fetchDosesList();
    }, []);




    const onClick = () => {
        setOpenModal(true);
    };

    const validateForm = () => {
        const errors = {};
        let isValid = true;

        if (!doseDetails.dose_number) {
            errors.dose_number = 'Dose Number is required';
            isValid = false;
        }

        if (!doseDetails.brand_id) {
            errors.brand_id = "Brand Id is required";
            isValid = false;
        }

        setErrorInputMessage(errors);
        return isValid;
    };

    const onSubmit = async () => {
        if (!validateForm()) {
            console.log("Form invalid");
            setTouchedFields({
                dose_number: true,
                brand_id: true,
            });
            return;
        }

        try {
            setLoading(true);
            console.log("doseDetails:", doseDetails);

            const response = await createDoses({
                program_id: programId,
                patient_id: patient_id,
                payload: {
                    doses: [{
                        dose_date: moment(doseDetails.dose_date).format('YYYY-MM-DD'),
                        dose_number: doseDetails.dose_number,
                        brand_id: doseDetails.brand_id
                    }]
                }
            });

            console.log("API response:", response);

            if (response.result) {
                setOpenModal(false);
                setConfirmation(true);
            }
        } catch (err) {
            console.error("Error submitting:", err);
            if (err?.inputs) {
                setErrorInputMessage(err.inputs);
            } else if (err?.message) {
                setErrorMessage(err.message);
            }
        } finally {
            setLoading(false);
        }
    }

    const onDateChange = (e) => {
        setDoseDetails(prevState => ({
            ...prevState,
            ['dose_date']: e,
        }));
    }
    const onFieldInput = (e) => {
        const { name, value } = e.target;
        setDoseDetails(prevState => ({
            ...prevState,
            [name]: value
        }));
        if (value && errorInputMessage?.[name]) {
            setErrorInputMessage(prev => ({
                ...prev,
                [name]: undefined
            }));
        }
    };

    const handleClose = (reload) => {
        setOpenModal(false);
        setConfirmation(false);
        setErrorMessage(null);
        setErrorInputMessage(null);
        setTouchedFields({
            dose_number: false,
            brand_id: false,
        });
        setDoseDetails({
            dose_date: currentDate.toDateString(),
            dose_number: '',
            brand_id: 'nucala',
        });

        if (reload) {
            window.location.reload();
        }
    };

    const brandList = [
        { id: 'nucala', name: 'Nucala' },
    ];

    const formContent = (
        <>
          {/*Dose Date */}
            <Grid
                item
                container
                xs={12}
                spacing={2}
            >
                <Grid item xs={6}>
                    <InputLabel>Dose Date</InputLabel>
                    <DatePicker
                        required={true}
                        onChange={onDateChange}
                        name='dose_date'
                        className={classes.field}
                        defaultValue={currentDate}
                        value={doseDetails.dose_date}
                    />
                    <Typography
                        variant='caption'
                        display='block'
                        gutterBottom
                        color='error'
                    >
                        {errorInputMessage ? errorInputMessage.dose_date : ''}
                    </Typography>
                </Grid>
            </Grid>
            {/* Dose Number */}
            <Grid item xs={12}>
                <InputLabel>Dose Number *</InputLabel>
                <TextField className={classes.field}
                    required={true}
                    name="dose_number"
                    type='number'
                    defaultValue={doseDetails.dose_number}
                    onChange={onFieldInput}
                />
                <Typography
                    variant='caption'
                    display='block'
                    gutterBottom
                    color='error'
                >
                    {errorInputMessage ? errorInputMessage.dose_number : ''}
                </Typography>

            </Grid>
            {/*Brand Id */}
            <Grid item xs={12}>
                <InputLabel>Brand *</InputLabel>
                <Select
                    required
                    label="Brand"
                    name="brand_id"
                    defaultValue={doseDetails.brand_id}
                    variant="outlined"
                    className={classes.field}
                    onChange={onFieldInput}
                    error={!!(touchedFields.brand_id && errorInputMessage?.brand_id)}
                    fullWidth
                    disabled
                >
                    {brandList.map(brand => (
                        <MenuItem key={brand.id} value={brand.id}>
                            {brand.name}
                        </MenuItem>
                    ))}
                </Select>
                {touchedFields.brand_id && errorInputMessage?.brand_id && (
                    <Typography className={classes.errorText}>
                        {errorInputMessage.brand_id}
                    </Typography>
                )}
            </Grid>
              {/*Dose Note */}
                {/* <Grid item xs={12}>
                        <TextField
                          required
                          label="Dose Notes *"
                          name="coordinator_notes"
                          value={applicationDetails.coordinator_notes}
                          variant='outlined'
                          className={classes.field}
                          onChange={onFieldInput}
                          onBlur={() => handleFieldBlur('coordinator_notes')}
                          error={!!(touchedFields.coordinator_notes && errorInputMessage?.coordinator_notes)}
                          multiline
                          rows={4}
                          fullWidth
                        />
                        {touchedFields.coordinator_notes && errorInputMessage?.coordinator_notes && (
                          <Typography className={classes.errorText}>
                            {errorInputMessage.coordinator_notes}
                          </Typography>
                        )}
                      </Grid> */}
        </>
    );

    const formButtons = (
        <>
            <Button onClick={() => handleClose(false)} variant='contained'>
                Close
            </Button>
            <Button
                onClick={onSubmit}
                variant='contained'
                color='secondary'
                disabled={isLoading}
            >
                {isLoading ? 'Submitting...' : 'Submit'}
            </Button>
        </>
    );

    if (isLoading) {
        return <LoadingOverlay />;
    }



    return (
        <>
            <Dialog
                className={classes.customWidth}
                open={openModal}
                title='Add New Doses'
                content={formContent}
                children={formButtons}
                onSubmit={onSubmit}
                onClose={() => handleClose(false)}
            />
            <Dialog
                key='confirmation'
                open={openConfirmation}
                title='Confirmation'
                content='Dose successfully created!'
                children={(
                    <Button onClick={() => handleClose(true)} variant='contained'>
                        Close
                    </Button>
                )}
                onSubmit={onSubmit}
                onClose={() => handleClose(true)}
            />
            <Button
                variant="contained"
                color="primary"
                onClick={onClick}
                style={{ marginRight: 8, marginBottom: 10 }}
            >
                + Add Doses
            </Button>
        </>
    )
}
export default AddDoses;